/**
 * @file useWxMpOAuthBootstrap.js
 * @description App 启动：消费 OAuth 回调 token，并拉取用户基础信息
 * @module shared/composables/useWxMpOAuthBootstrap
 */

import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { consumeOAuthTokenFromRoute } from '@/shared/utils/wxMpOAuth'
import { saveAuthUser } from '@/shared/utils/auth'
import { getStoredUser } from '@/shared/utils/storage'

/**
 * 挂载时处理公众号 OAuth 回跳 token
 * @param {{ onSessionRestored?: (userData: Record<string, unknown>) => void }} [options]
 */
export function useWxMpOAuthBootstrap(options = {}) {
  const router = useRouter()
  const userStore = useUserStore()

  /**
   * @returns {Promise<boolean>} 是否消费了 OAuth token
   */
  async function bootstrapOAuthToken() {
    const consumed = await consumeOAuthTokenFromRoute(router)
    if (!consumed) return false

    const session = getStoredUser()
    if (!session?.token) return false

    userStore.setUser(session)
    options.onSessionRestored?.(session)

    await userStore.fetchUserInfo()

    const merged = {
      ...session,
      ...userStore.user,
      token: session.token,
      expiration: session.expiration,
    }
    saveAuthUser(merged)
    options.onSessionRestored?.(merged)
    return true
  }

  return { bootstrapOAuthToken }
}
